import { render } from "./SuggestionItem.vue?vue&type=template&id=328d5007&scoped=true&ts=true"
import script from "./SuggestionItem.vue?vue&type=script&lang=ts"
export * from "./SuggestionItem.vue?vue&type=script&lang=ts"

import "./SuggestionItem.vue?vue&type=style&index=0&id=328d5007&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328d5007"]])

export default __exports__